<template>
  <div>
    <div v-if="step === 'afterSale'" class="AfterSale div-layout">
      <module-title title="售后服务" />
      <div class="AfterSale-main">
        <el-form
          ref="afterSaleStatisticsForm"
          :model="searchForm"
          :inline="true"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="设备SN号：" prop="deviceNo">
            <el-input
              v-model="searchForm.deviceNo"
              name="deviceNo"
              maxlength="20"
              placeholder="输入设备SN号"
              class="handle-form-input"
              clearable
            />
          </el-form-item>
          <el-form-item label="超管账号：" prop="adminPhone">
            <el-input
              v-model="searchForm.adminPhone"
              name="adminPhone"
              maxlength="20"
              placeholder="输入超管账号"
              class="handle-form-input"
              clearable
            />
          </el-form-item>
          <el-form-item label="时间段：" prop="periodType">
            <el-select
              v-model="searchForm.periodType"
              name="periodType"
              size="medium"
              class="handle-form-input"
            >
              <el-option
                v-for="item in periodTypeList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left: 50px">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
        <el-table
          v-loading="listLoading"
          :data="afterSaleList"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column
            type="index"
            width="55"
            align="center"
            label="序号"
          />
          <el-table-column
            label="课桌设备SN号"
            align="center"
            prop="deviceNo"
          />
          <el-table-column label="主板版本" align="center" prop="systemMainboardVersion" />
          <el-table-column label="超管账号" align="center" prop="mobile" />
          <!-- <el-table-column label="超管昵称" align="center" prop="name" /> -->
          <el-table-column label="启用日期" prop="activeDate" align="center" />
          <el-table-column
            label="启用至今（天数）"
            prop="activeDay"
            align="center"
          />
          <el-table-column label="操作" align="center" width="400">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                @click="handleUntie(scope.row)"
              >
                解绑
              </el-button>
              <el-button
                type="primary"
                size="small"
                @click="viewDetail(scope.row, 1)"
              >
                更换账号手机号
              </el-button>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-view"
                @click="viewVersionDetail(scope.row)"
              >
                版本信息
              </el-button>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-view"
                @click="viewDetail(scope.row, 0)"
              >
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
      <!-- 班级详情 -->
      <el-dialog
        v-if="dialogDetailVisible"
        :close-on-click-modal="false"
        :visible.sync="dialogDetailVisible"
        :title="dialogTitle"
        :before-close="handleBeforeClose"
        width="650px"
      >
        <!-- 查看 -->
        <div v-if="dialogStatus === 0" class="manager-info">
          <ul>
            <li>
              <label for>总天数（天）：</label>
              {{ afterSaleDetail.totalDays }}
            </li>
            <li>
              <label for>总登录（次数）：</label>
              {{ afterSaleDetail.totalLoginTimes }}
            </li>
            <li>
              <label for>总时长（小时）：</label>
              {{ afterSaleDetail.totalTime }}
            </li>
          </ul>
          <!-- v17.1 ul删除-->
          <!-- <ul>
          <li>
            <label for>小孩（数量）：</label>
            {{afterSaleDetail.studentCount}}
          </li>
          <li>
            <label for>学习模块（数量）：</label>
            {{afterSaleDetail.contentCount}}
          </li>
          <li>
            <label for>学习时长（小时）：</label>
             {{afterSaleDetail.duration}}
          </li>
        </ul> -->
        </div>
        <!-- 更换账号手机号 -->
        <div v-else>
          <el-form
            ref="handleForm"
            :model="handleForm"
            :rules="handleRules"
            label-position="right"
            hide-required-asterisk
          >
            <el-form-item label="" prop="mobile" class="ch">
              请核实设备超管身份信息，谨慎操作！
            </el-form-item>
            <el-form-item label="设备SN号：">
              {{ handleForm.deviceNo }}
            </el-form-item>
            <el-form-item label="超管绑定的手机号：">
              {{ handleForm.oldPhone }}
            </el-form-item>
            <div class="title-box">
              <span>新的号码</span>
              <el-checkbox v-if="versionType==5" v-model="handleForm.virtualNumber" :disabled="versionType==5?true:false">
                虚拟号码
              </el-checkbox>
            </div>
            <el-form-item prop="phone">
              <el-input
                v-model.number="handleForm.phone"
                :rows="6"
                placeholder="请输入新的手机号"
                class="handle-form-input"
                maxlength="11"
                show-word-limit
                @input="handleMobile"
              />
            </el-form-item>
            <el-form-item v-if="handleForm.virtualNumber == false" label="" prop="smsCode" :rules="[{ required: handleForm.virtualNumber ==false?true:false, message: '验证码不能为空', trigger: 'blur', }]">
              <el-input
                v-if="handleForm.virtualNumber == false"
                v-model="handleForm.smsCode"
                placeholder="请输入验证码"
                maxlength="6"
              >
                <el-button
                  slot="append"
                  class="verifyCode"
                  :disabled="verifyCoDedisabled"
                  @click="handleSend"
                >
                  {{ verifyCode }}
                </el-button>
              </el-input>
            </el-form-item>
            <el-form-item
              v-show="phoneStatusShow"
              v-if="handleForm.virtualNumber == false"
              label=""
              :class="phoneCpd('className')"
            >
              {{ phoneCpd("text") }}
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="handleClose">
              取消
            </el-button>
            <el-button
              :loading="ajaxLoading"
              type="primary"
              size="medium"
              :disabled="phoneStatus === 1 && handleForm.virtualNumber == false"
              @click="handleAddSubject"
            >
              {{ ajaxLoading ? "Loading" : "确认" }}
            </el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <VersionInfo v-else :data-prpos="versionInfoPrpos" @back="back" />
  </div>
</template>

<script>

import VersionInfo from './versionInfo';
import {
  getAfterSaleList,
  getAfterSaleDetail
} from '@/api/productOperation/mrDesk/statistics';
import {
  isRegisterPhone,
  updateUserPhone,
  sendUpdatePhoneSms,
  unbindingDevice
} from '@/api/productOperation/mrDesk/afterSale';

export default {
  name: 'AfterSaleStatistics',
  components: {
    VersionInfo
  },
  data() {
    return {
      // 搜索表单
      searchForm: {
        deviceNo: '',
        periodType: '1',
        adminPhone: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      step: 'afterSale',
      versionInfoPrpos: {},
      listLoading: false,
      dialogDetailVisible: false,
      afterSaleList: [],
      afterSaleDetail: {},
      // 弹窗口类型判断
      dialogStatus: 0,
      dialogTitle: '设备信息',
      phoneStatus: -1,
      phoneStatusShow: false,
      handleForm: {
        deviceNo: '',
        oldPhone: '',
        phone: '',
        smsCode: '',
        virtualNumber: false
      },
      handleRules: {
        phone: [
          { required: true, message: '新的手机号不能为空', trigger: 'blur' },
          {
            // /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/
            // pattern: /^(12[0-9]|13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/,
            // message: '请输入正确的手机号',
            // trigger: 'blur'
            validator: this.validatePhoneNumber, trigger: 'blur'
          }
        ]
        // smsCode: [
        //   { required: true, message: '验证码不能为空', trigger: 'change' }
        // ]
      },
      verifyCode: '发送验证码',
      verifyCoDedisabled: true,
      ajaxLoading: false,
      timer: null,
      versionType: ''
    };
  },
  computed: {
    periodTypeList() {
      return [
        {
          code: '1',
          name: '一个月'
        },
        {
          code: '2',
          name: '两个月'
        },
        {
          code: '3',
          name: '三个月'
        },
        {
          code: '0',
          name: '三个月以上'
        }
      ];
    },
    phoneCpd() {
      return (type) => {
        let className = '';
        let text = '';
        if (this.phoneStatus === 0) {
          className = 'cl';
          text = '可以更换';
        } else if (this.phoneStatus === 1) {
          className = 'ch';
          text = '该号码已是注册用户，不可更换！';
        }
        const messages = {
          className,
          text
        };
        return messages[type];
      };
    }
  },
  mounted() {
    this.fetchAfterSaleList();
  },
  methods: {
    validatePhoneNumber(rule, value, callback) {
      if (this.handleForm.virtualNumber) {
        const regex = /^1266\d{7}$/;
        if (!regex.test(value)) {
          callback(new Error('虚拟号请以1266开头，11位数字'));
        } else {
          callback();
        }
      } else {
        const regex1 = /^(13|14|15|16|17|18|19)\d{9}$/;
        if (!regex1.test(value)) {
          callback(new Error('手机号格式不正确'));
        } else {
          callback();
        }
      }
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchAfterSaleList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchAfterSaleList();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchAfterSaleList();
    },

    // 查看详情
    viewDetail(row, status) {
      if (status === 0) {
        this.dialogTitle = '设备信息';
        this.dialogStatus = 0;
        getAfterSaleDetail(row.deviceNo)
          .then((res) => {
            this.afterSaleDetail = res.data;
            this.dialogDetailVisible = true;
          })
          .catch((err) => {
            console.log(err);
            this.afterSaleDetail = {};
          });
      } else {
        this.dialogTitle = '更换账号手机号';
        this.dialogStatus = 1;
        this.dialogDetailVisible = true;
        this.handleForm.deviceNo = row.deviceNo;
        this.handleForm.oldPhone = row.mobile;
        this.versionType = row.type;
        this.handleForm.virtualNumber = row.type === '5';
      }
    },

    // 获取售后数据
    fetchAfterSaleList() {
      this.listLoading = true;
      var option = {
        deviceNo: this.searchForm.deviceNo,
        periodType: this.searchForm.periodType,
        adminPhone: this.searchForm.adminPhone,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      getAfterSaleList(option)
        .then((res) => {
          if (res.data && res.data.list && res.data.list.length) {
            this.afterSaleList = res.data.list;
            this.searchForm.total = res.data.total;
          } else {
            this.afterSaleList = [];
            this.searchForm.total = 0;
          }
          this.listLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.afterSaleList = [];
          this.total = 0;
          this.listLoading = false;
        });
    },
    handleUntie(row) {
      this.$confirm(`确定将课桌设备SN（${row.deviceNo}）与超管账号（${row.mobile}）解绑吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        unbindingDevice(row.deviceNo).then((res) => {
          if (res.code === '0') {
            this.$message.success('解绑成功');
            this.fetchAfterSaleList();
          }
        });
      }).catch(() => {});
    },
    viewVersionDetail(row) {
      this.step = 'versionInfo';
      this.versionInfoPrpos = row;
    },

    back() {
      this.step = 'afterSale';
      this.fetchAfterSaleList();
    },
    // 输入框手机号码校验
    handleMobile(value) {
      value = value.trim();
      if (!value || value.length !== 11) {
        this.phoneStatus = -1;
        this.verifyCoDedisabled = false;
        this.phoneStatusShow = false;
        return;
      }
      this.phoneStatusShow = value.length === 11;
      isRegisterPhone({ phone: value })
        .then((res) => {
          this.phoneStatus = res.code === '500' ? 1 : 0;
          this.verifyCoDedisabled = res.code === '500';
        })
        .catch((err) => {
          this.phoneStatus = err.data.code === '500' ? 1 : 0;
          this.verifyCoDedisabled = err.data.code === '500';
        });
    },
    // 验证码
    handleSend() {
      sendUpdatePhoneSms({ phone: this.handleForm.phone }).then(() => {
        this.$message({
          message: '短信发送成功',
          type: 'success'
        });
        this.verifyCoDedisabled = true;
        var n = 60;
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.timer = setInterval(() => {
          if (!n || n <= 0) {
            this.verifyCode = '重新获取验证码';
            this.verifyCoDedisabled = false;
            clearInterval(this.timer);
          } else {
            n -= 1;
            this.verifyCode = n + '秒后可重发';
            this.verifyCoDedisabled = true;
          }
        }, 1000);
      });
    },
    // 弹窗确认
    handleAddSubject() {
      if (!this.handleForm.oldPhone) {
        this.$message({
          message: '当前账号未绑定超管，无法进行更换操作',
          type: 'error'
        });
        return;
      }
      this.$refs['handleForm'].validate((valid) => {
        if (valid) {
          updateUserPhone(this.handleForm).then(() => {
            this.fetchAfterSaleList();
            this.$message({
              message: '更换成功',
              type: 'success'
            });
            this.initOptions();
            this.clearCode();
            this.dialogDetailVisible = false;
          });
        } else {
          return false;
        }
      });
    },
    // 初始化弹窗中输入内容数据
    initOptions() {
      this.handleForm.phone = '';
      this.handleForm.smsCode = '';
      this.phoneStatusShow = false;
    },
    // 弹窗关闭
    handleClose() {
      this.initOptions();
      this.clearCode();
      this.verifyCoDedisabled = true;
      this.dialogDetailVisible = false;
    },
    // 弹窗关闭拦截
    handleBeforeClose(done) {
      this.initOptions();
      this.clearCode();
      done();
    },
    // 弹窗关闭，发送短信验证处理
    clearCode() {
      clearInterval(this.timer);
      this.verifyCode = '获取验证码';
      this.verifyCoDedisabled = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.AfterSale {
  .handle-form-input {
    width: 200px;
  }
  .title-box{
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
    }
  .manager-info {
    display: flex;
    ul {
      margin-left: 60px;
      width: 100%;
      min-width: 220px;
      li {
        label {
          margin-right: 10px;
        }
        margin-bottom: 20px;
      }
    }
  }
  .el-input {
    width: 100%;
  }
  .dialog-footer {
    text-align: right;
    padding-top: 20px;
  }
  .verifyCode {
    border: 0;
    color: #409eff;
  }
}
</style>
